import { useLocation } from "react-router-dom";

export default function useBackPathFromUrl() {
    const location = useLocation();
    const Url = location.pathname
    return Url.substring(0, Url.lastIndexOf("/"))
}
